import '../modalWrapper.scss';
import './modal-withdrawal.scss';

import Warning from '../../../../assets/images/icons/caution.png';
import Success from '../../../../assets/images/icons/check.png';
import Error from '../../../../assets/images/icons/cancel.png';


import React, { FunctionComponent, useEffect, useState } from 'react';
import Stepper from '../components/stepper';
import { useAppDispatch, useAppSelector } from '../../../../features';
import { textFormatterWalletHiddenChars } from '../../../../utils/textFormatter';
import { useStepper } from '../../../../features/stepper';
import { StepProps } from '../../../../types/helpers';
import { WithDrawCards } from '../components/withdraw-cards';
import { ModalButton } from '../../button-modal';
import { getCurrentWorkingPair, getMakewithdrawalStatus, getWithdrawalIsDone, getWithdrawalPreview, makeWithdrawal, requestWithdrawalPreview, setCurrentWorkingPair, setMakewithdrawalStatus } from '../../../../store/TransactionSlice';
import { getNposProfile, getUserInfo, getUserProfile } from '../../../../store/UserSlice';
import { getIsNpos, setModalSignInUp } from '../../../../store/AppSlice';
import { modalTypeEnum } from '../../../../types/modal';
import { useNavigate } from 'react-router-dom';
import { TRKLoader } from '../../loader/loader';

type previewInfo = {
    code: number,
    status: number,
    data: {
        pair: string,
        code: number,
        message: string,
        auto_charges_failed: {
            charges: Array<any>,
            total: number
        }
        balance: {
            pending: {
                locked_amount: number,
                orig_amount:number,
                qty: number
            },
            ['waiting-withdrawal'] : {
                locked_amount: number,
                orig_amount:number,
                qty: number
            }
        }
    }
}

enum redirectEnum {
    home = '',
    history = 'history',
    profile = 'profile',
}

type Purchases = {
    amount: number,
    qty: number
}

const defaultPair = 'USDT:fiatBRL';

export const ModalWithdrawal: FunctionComponent = () => {

    let Component: React.ElementType = () => <></>; // Default - Elemento Vazio

    const [step, increaseStep, decreaseStep, setStep] = useStepper(0);

    Component = [
        WithdrawalPreview,
        TotalAmountPreview,
        WithdrawalWallet,
        SuccessInfo
    ][step];

    return (
        <div className="modal modal-withdrawal">
            <Stepper currentStep={step}></Stepper>
            <Component increaseStep={increaseStep} setStep={setStep} decreaseStep={decreaseStep}/>
        </div>
    )
}

const WithdrawalPreview: FunctionComponent<StepProps> = (props) => {

    const dispatch                                  = useAppDispatch();
    const preview : previewInfo                     = useAppSelector(getWithdrawalPreview);
    const [loading, setLoading]                     = useState<boolean>(true);
    const [label, setLabel]                         = useState<string>('Concordar');

    const handleClick = () => {
        if(preview.code === 200) {
            props.increaseStep();
        } else dispatch(setModalSignInUp(modalTypeEnum.none));
    }

    useEffect( () => {
        dispatch(setCurrentWorkingPair(defaultPair));
        dispatch(requestWithdrawalPreview(defaultPair));
        setLoading(true);
    }, [dispatch])

    useEffect( () => {

        if(preview && preview.data) {
            
            setLoading(false);

            if (preview.status && preview.status === 400) {
                setLabel('Fechar');
            } else if (preview.code === 200) {
                if (preview.data.balance.pending || preview?.data?.auto_charges_failed?.charges.length > 0) {
                    setLabel('Realizar e Continuar')
                } else if (!preview.data.balance.pending && preview.data.auto_charges_failed.charges.length === 0) {
                    setLabel('Continuar');
                    props.increaseStep();
                } else {
                    setLabel('Continuar');
                }
            }
        }

    }, [preview,setLoading,props])

    const verifyAmount = () => {

        let amount = 0;

        const pending = preview.data.balance.pending?.orig_amount || 0;
        const failedCharges = preview.data.auto_charges_failed.charges.length > 0 
            ? preview.data.auto_charges_failed.total 
            : 0;
    
        amount = Number(pending) + Number(failedCharges);
        return amount;
    }

    const verifyQty = () => {
        let qty = 0;

        const pending = preview.data.balance.pending?.qty || 0;
        const failedCharges = preview.data.auto_charges_failed.charges.length;

        qty = Number(pending) + Number(failedCharges);
        return qty;
    }

    return(
        <>

            { loading ?
                <TRKLoader/>
            :(
                <>
                    { preview.status && preview.status === 400 && (   
                        <div className="withdrawal-preview">
                            <h1 className="withdraw-title">
                                Passo 1:
                                <small>
                                    Verificação da sua conta, para balanço e ordens em aberto:
                                </small>
                            </h1>
                            <div className="card card-withdraw">
                                <h2>
                                    Nenhuma transação elegível para saque foi encontrada. Não é possível continuar com o processo. <br/>
                                </h2>
                            </div>
                        </div>
                    )}

                    { !preview.status && !preview.data.auto_charges_failed && !preview.data.balance.pending && (
                        // nao tem charger to execute
                        <div className="withdrawal-preview">
                            <h1 className="withdraw-title">
                                Passo 1:
                                <small>
                                    Verificamos e sua conta não possui ordens de troca em aberto. Agora é só prosegguir para o próximo passo.
                                </small>
                            </h1>
                            <div className="card card-withdraw">
                                <h2>Você não possui ordens em aberto para realizar a troca, apenas siga para o próximo passo!</h2>
                            </div>
                        </div>
                    )}

                    { !preview.status && (preview.data.auto_charges_failed.charges.length > 0 || preview.data.balance.pending) && ( 
                        <div className="withdrawal-preview">
                            <h1 className="withdraw-title">
                                Passo 1:
                                <small>
                                    Informamos que você possui transações em aberto. Ao prosseguir, 
                                    essas transações serão liquidadas pelo valor de mercado vigente.<br/>
                                    Veja abaixo o valor:
                                </small>
                            </h1>
                            <WithDrawCards 
                                category={'pending'} 
                                amount={ verifyAmount() }
                                qty={verifyQty()}/>
                            
                        </div>
                    )}
                </>
            )}
            <ModalButton label={label} disabled={loading} onClick={() => handleClick()} />
        </>
    )
}

const TotalAmountPreview: FunctionComponent<StepProps> = (props) => {

    const dispatch = useAppDispatch();

    const pair : any = useAppSelector(getCurrentWorkingPair);
    const preview : previewInfo = useAppSelector(getWithdrawalPreview);

    const [loading, setLoading] = useState<boolean>(false); 

    useEffect( () => {
        setLoading(true);
        dispatch(requestWithdrawalPreview(pair));
    },[dispatch, pair])

    useEffect( () => {
        console.dir(preview);
        setLoading(false);
    },[preview] )

    return(
        <div className="withdrawal-amount">
            <h1 className="withdraw-title">
                Passo 2:
                <small>
                    Abaixo o valor total de todas os cobranças de trocas que foram realizadas no modo swap automático, definido no perfil. <br/>
                    Veja abaixo o valor:
                </small>
            </h1>
            <WithDrawCards category={'current'} amount={preview?.data?.balance?.['waiting-withdrawal']?.locked_amount} currency='USDT'/>
            <ModalButton label={'Continuar'} disabled={loading} onClick={() => props.increaseStep()} />
        </div>
    )
}

const WithdrawalWallet: FunctionComponent<StepProps> = (props) => {
    
    const dispatch = useAppDispatch();

    const userInfoData : any        = useAppSelector(getUserInfo);
    const withdrawalStatus          = useAppSelector(getMakewithdrawalStatus);
    const [loading, setLoading]     = useState<boolean>(false);

    // loader
    const withdrawalStatusDone : boolean                = useAppSelector(getWithdrawalIsDone);
    const [isLoadingWithdrawal, setIsLoadingWithdrawal] = useState<boolean>(false);

    
    useEffect( () => {
        setIsLoadingWithdrawal(withdrawalStatusDone);
    },[withdrawalStatusDone]);

    useEffect(() => {
        if (withdrawalStatus !== undefined && withdrawalStatus !== null) {   
            if (withdrawalStatus > 0) {
                props.increaseStep();
            }
        }
    }, [withdrawalStatus, props]);

    const handleClick = () => {
        setIsLoadingWithdrawal(true);
        setLoading(true);
        dispatch(makeWithdrawal())
    }

    return(
        <div className="withdrawal-wallet">
            <h1 className="withdraw-title">
                Passo 3:
                <small>
                    Confira a carteira destino, para a qual serão enviadoss o valor total.<br/>
                    Verifique a chave abaixo:
                </small>
            </h1>
            <p>
                { textFormatterWalletHiddenChars(userInfoData?.wallet?.hash_address, 8) }
            </p>
            { !isLoadingWithdrawal ? (
                <ModalButton label={'Realizar o saque'} disabled={loading} onClick={() => handleClick()} />
            ):(
                <div className="loading-flex">
                    <div className="loaderBars"></div>
                </div>
            )}
        </div>
    )
}

const SuccessInfo: FunctionComponent<StepProps> = (props) => {

    const loading = false;

    const navigate = useNavigate()
    const dispatch = useAppDispatch();
    
    const withdrawalStatus = useAppSelector(getMakewithdrawalStatus);
    const isNpos: boolean                       = useAppSelector(getIsNpos);

    const handleClick = (category: string) => {
        if (isNpos) dispatch(getNposProfile())
        else dispatch(getUserProfile())

        dispatch(setMakewithdrawalStatus(0))
        dispatch(setModalSignInUp(modalTypeEnum.none))
        navigate('/'+category)
    }

    return(
        <div className="withdrawal-success">
            <div className="finish-text">
                { withdrawalStatus && withdrawalStatus === 201 && 
                    <>
                        <img src={Success} alt="" />
                        <h1>Processando sua solicitação</h1>
                        <p>
                            Estamos quase lá! Sua solicitação está sendo processada e isso pode levar alguns instantes. Agradecemos pela paciência e garantimos que em breve tudo estará em sua carteira.
                        </p>
                        <ModalButton label={'Voltar para o APP'} disabled={loading} onClick={() => handleClick(redirectEnum.home)} />
                    </>
                }
                { withdrawalStatus && withdrawalStatus === 400 && 
                    <>
                        <img src={Warning} alt="" />
                        <h1>Outra solicitação em processo</h1>
                        <p>
                            Parece que já há uma solicitação em andamento. Por favor, aguarde a finalização antes de tentar novamente. Obrigado por sua paciência!
                        </p>
                        <ModalButton label={'Entendi, voltar para o APP'} disabled={loading} onClick={() => handleClick(redirectEnum.history)} />
                    </>
                }
                { withdrawalStatus && withdrawalStatus !== 201 && withdrawalStatus !== 400 && 
                    <>
                        <img src={Error} alt="" />
                        <h1>Erro ao solicitar o saque</h1>
                        <p>
                        Ops! Algo deu errado. Se o problema persistir, entre em contato com o suporte e teremos prazer em ajudar.
                        </p>
                        <ModalButton label={'Falar com suporte'} disabled={loading} onClick={() => handleClick(redirectEnum.profile)} />
                    </>
                }
            </div>
        </div>
    )
}
